import { CalendarDays } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const bookings = defineDashboardModule({
  id: "bookings",
  requires: ["clients"],
  nav: [
    {
      group: "Business",
      title: "Bookings",
      to: "/bookings",
      icon: CalendarDays,
    },
  ],
  routes: [
    {
      path: "/bookings",
      component: lazyPage(
        () => import("./routes/booking-list"),
        "BookingsPage"
      ),
    },
    {
      path: "/bookings/new",
      component: lazyPage(
        () => import("./routes/booking-new"),
        "BookingNewPage"
      ),
    },
    {
      path: "/bookings/:id",
      component: lazyPage(
        () => import("./routes/booking-detail"),
        "BookingDetailPage"
      ),
    },
  ],
})
